import { useQuery } from "@tanstack/react-query";
import { actions, isInputError } from "astro:actions";
import { useId, useMemo, useState } from "react";

import { FormControl } from "../FormControl";
import { Input } from "../Input";

export const CollectionSelect: React.FC<{
  defaultValue?: string;
  error: Error | null;
}> = ({ defaultValue = "", error }) => {
  const id = useId();
  const [value, setValue] = useState(defaultValue);
  const isNew = useMemo(() => value === "new", [value]);

  const { data, isLoading } = useQuery({
    queryKey: ["collections"],
    queryFn: actions.me.getCollections.orThrow,
  });

  return (
    <FormControl
      id={id}
      label="Collection"
      error={isInputError(error) ? error?.fields.collection?.[0] : undefined}
    >
      <div className="flex flex-col gap-4">
        <select
          id={isNew ? undefined : id}
          disabled={isLoading}
          className="select select-bordered"
          name={isNew ? undefined : "collectionId"}
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
          }}
        >
          <option value="">Select a collection (optional)</option>
          <option value="new">Create new collection</option>
          <optgroup label="Collections">
            {data?.map((collection) => (
              <option key={collection.id} value={collection.id}>
                {collection.name}
              </option>
            ))}
          </optgroup>
        </select>
        {isNew && (
          <Input
            required
            name="collection"
            placeholder="Give your collection a name"
            id={id}
          />
        )}
      </div>
    </FormControl>
  );
};
